const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  optionValueSelectionChange: "option-value-selection-change",
  variantChange: "variant-change",
  cartError: "cart-error",
};

const AlpineStoreKeys = {
  FREE_GIFT_STORE: "freeGiftStore",
  FREE_SHIPPING_THRESHHOLD_STORE: "freeShippingThresholdStore"
};

window.ON_CHANGE_DEBOUNCE_TIMER = ON_CHANGE_DEBOUNCE_TIMER;
window.PUB_SUB_EVENTS = PUB_SUB_EVENTS;
window.AlpineStoreKeys = AlpineStoreKeys;
